import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function GeneralQuoteDialog({ open, onOpenChange }) {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ product_name: "", quantity: 100, unit: "piece", details: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const inputCls =
    "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20";

  const submit = async (e) => {
    e.preventDefault();
    if (!user) {
      onOpenChange(false);
      navigate("/login?next=/");
      return;
    }
    setLoading(true);
    try {
      await api("/rfq", {
        method: "POST",
        auth: true,
        body: { ...form, quantity: Number(form.quantity), product_id: null },
      });
      toast.success(t("req_quote_t"));
      onOpenChange(false);
      setForm({ product_name: "", quantity: 100, unit: "piece", details: "" });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="general-quote-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading">{t("quick_rfq")}</DialogTitle>
          <DialogDescription>{t("quick_rfq_sub")}.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">{t("looking_for")}</label>
            <input data-testid="general-quote-product" required value={form.product_name} onChange={set("product_name")} className={inputCls} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm font-medium text-slate-700">{t("qty")}</label>
              <input data-testid="general-quote-quantity" type="number" min={1} required value={form.quantity} onChange={set("quantity")} className={inputCls} />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700">{t("unit")}</label>
              <input data-testid="general-quote-unit" value={form.unit} onChange={set("unit")} className={inputCls} />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">{t("details_supplier")}</label>
            <textarea data-testid="general-quote-details" rows={3} value={form.details} onChange={set("details")} className={inputCls} />
          </div>
          <button
            data-testid="general-quote-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-teal-700 py-2.5 text-sm font-bold text-white hover:bg-teal-800 transition active:scale-95 disabled:opacity-60"
          >
            {loading ? t("sending") : user ? t("send_request") : t("login_quote")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
